/**************************************************
 * Nombre:       Dialogo_Despacho
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import {useFormulario} from "../../../Modulo_formularios/Hooks/useFormulario";
import {useEffect} from "react";
import {guardarDoc} from "../../../Servicios/BD/guardarDoc";
import {useCargador} from "../../../Modulo_Cargador/Hooks/useCargador";
import logoRedondo from "../../../Recursos/logo_redondo.png";
import Formulario_Reserva_Adicionales from "../../Formularios/Reservas/Formulario_Reserva_Adicionales";
import {obtenerValorTotal} from "../../Utilidades/obtenerValorTotal";
import {obtenerValorSaldo} from "../../Utilidades/obtenerValorSaldo";

const Dialogo_Adicionales = ({datos, cerrar, realizado}) => {
    const {
        props,
        obtenerEntidad
    } = useFormulario({valoresDefecto: datos})
    const {Cargador, Avisos, iniciarCarga, nuevoAviso, terminar} = useCargador({
        logoRedondo: logoRedondo,
        funcionUno: realizado,
        funcionDos: cerrar,
        key: 'uno'
    })


    const subirDatos = async () => {

        let entidad = await obtenerEntidad()

        iniciarCarga('Subiendo datos')
        let result = await guardarDoc('reservas', entidad)
        if (result.res) {
            terminar({aviso: 'Datos actualizados con exito'})
        } else {
            terminar({aviso: 'Ups! no se subieron los datos, intentalo nuevamente', variante: 'error'})
        }

    }



    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Cargador/>

            <Avisos/>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Formulario_Reserva_Adicionales props={props}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => subirDatos()}
                >Guardar Datos</Button>
            </Grid>


        </Grid>
    )

}
export default Dialogo_Adicionales